import { render, staticRenderFns } from "./FieldComparison.vue?vue&type=template&id=a06b2282&scoped=true&"
import script from "./FieldComparison.vue?vue&type=script&lang=js&"
export * from "./FieldComparison.vue?vue&type=script&lang=js&"
import style0 from "./FieldComparison.vue?vue&type=style&index=0&id=a06b2282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06b2282",
  null
  
)

export default component.exports